import { PropsWithChildren } from 'react';
import { Icon, Label } from '@facephi/ui-react';
import { Property } from 'csstype';
import Skeleton from 'react-loading-skeleton';
import { OperationsCardIcon, OperationsCardStatusStyles } from './Styles';
import { StateIconInfo } from '../model';

type Props = {
  label: string;
  type: StateIconInfo;
  loading?: boolean;
};

const SkeletonWrapper = ({
  children,
  textAlign,
}: PropsWithChildren<unknown> & { textAlign?: Property.TextAlign }) => (
  <div style={{ width: '100%', textAlign }}>{children}</div>
);

export const OperationsCardStatus = ({ label, type, loading }: Props) => {
  return (
    <OperationsCardStatusStyles
      $statusColor={type.backgroundColor}
      alignItems="center"
      justifyContent="space-between"
      columnGap="1"
    >
      {loading ? (
        <>
          <SkeletonWrapper>
            <Skeleton height={18} width="40%" borderRadius={8} />
          </SkeletonWrapper>
          <SkeletonWrapper textAlign="right">
            <Skeleton height={18} width="40%" borderRadius={8} />
          </SkeletonWrapper>
        </>
      ) : (
        <>
          <Label fontSize="14" semibold color={type.iconColor}>
            {label}
          </Label>
          <OperationsCardIcon $bgColor={type.iconColor}>
            <Icon
              iconName={type.iconName}
              size="16"
              color="white"
              weight="fill"
            />
          </OperationsCardIcon>
        </>
      )}
    </OperationsCardStatusStyles>
  );
};
